import React, { useEffect } from 'react';
import styled from "@emotion/styled";
import { RootState, i18n, mq, setFlowType, setProgressBarPercentage, useAppDispatch, useAppSelector, PartnerEnum } from 'src/common';
import { Card, CustomerForm, HtmlText, HtmlTextLink, Text } from 'src/components';

const CardStyle = styled(Card)(
  mq({
    padding: ['16px', '16px', "24px", "24px", "40px"],
    marginBottom: 16
  }))

const TitleStyle = styled(Text)({
  marginBottom: 16
})

const htmlTextLinks: Array<HtmlTextLink> = [
  { value: 'form', link: 'https://kompare.hr/obrazac-za-prituzbe/', translation: i18n.t('pages.customerPage.htmlTextLinkTranslations.form') },
  { value: 'mail', link: 'mailto:szop@kompare.hr', translation: 'szop@kompare.hr' },
  { value: 'here', link: 'https://kompare.hr/informacije-o-koristenju-osobnih-podataka/', translation: i18n.t('pages.customerPage.htmlTextLinkTranslations.here') },
  { value: 'privacyPolicy', link: 'https://kompare.hr/informacije-o-koristenju-osobnih-podataka/', translation: i18n.t('pages.customerPage.htmlTextLinkTranslations.privacyPolicy') },
  { value: 'terms', link: 'https://kompare.hr/uvjeti-koristenja/', translation: i18n.t('pages.customerPage.htmlTextLinkTranslations.terms') },
];

const CustomerBrziPregledPage = () => {
  const dispatch = useAppDispatch();
  const birthDate = useAppSelector((store: RootState) => store.model.customer.data.birthDate);

  useEffect(() => {
    dispatch(setProgressBarPercentage(20));
    dispatch(setFlowType('web'));
  }, []);

  return (
    <>
      <CardStyle title={<TitleStyle type="large" bold>{i18n.t('pages.customerPage.title')}</TitleStyle>}>
        <CustomerForm customer={{ birthDate }} partnerSource={PartnerEnum.BRZIPREGLED} formItems={['birthDate', 'email', 'phoneNumber', 'hasPolicy']} />
      </CardStyle>
      <HtmlText i18nKey="pages.customerPage.gdprConsentWithParams" links={htmlTextLinks} />
    </>
  );
}

export default CustomerBrziPregledPage;
